import {
  GoogleMapConstants
} from "../../constants";

const {GET_LOCATION_DETAIL} = GoogleMapConstants;

const initialState = {
  countryCode: "",
  city: ""
};

const googleMap = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATION_DETAIL:
      return {
        ...state,
        countryCode: action.data?.countryCode,
        city: action.data?.city
      };
    default:
      return state;
  }
};

export default googleMap;
